






























import { ssmPermissionService } from "@/shared/services/PermissionService";
import { UtilsString } from "@/utils/utils-string";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class Xbtn extends Vue {
  @Prop({ default: "primary" }) color!: string;
  @Prop({ default: false, type: Boolean }) icon!: boolean;
  @Prop({ default: false, type: Boolean }) text!: boolean;
  @Prop({ default: false, type: Boolean }) small!: boolean;
  @Prop({ default: UtilsString.Empty }) permiso!: string;
  @Prop({ default: () => [] }) permisos!: string[];
  @Prop({ default: "" }) customClass!: string;

  get visible() {
    if (this.permisos.length === 0) {
      if (this.permiso === UtilsString.Empty) {
        return true;
      }
      return ssmPermissionService.hasPermission(this.permiso);
    } else {
      return this.permisos.some((p) => ssmPermissionService.hasPermission(p));
    }
  }
}
